import React from 'react'
import { FcGlobe } from "react-icons/fc";

import './../qasim.css';

import Slider from "./slider";

import SiteHome, { LinesAnimation, BallMove } from "./home.style";


const Sitehome = () => {
    return (
      <>
      <SiteHome>
        {/* <br /> */}
        <Slider/>
        <LinesAnimation> Welcome to TechSchema React hub</LinesAnimation>
        <BallMove>
          <FcGlobe
            className="ball"
            size={100}
            style={{ position: "relative", top: "40px", right: "24px" }}
          />
          <span style={{ fontFamily: "cursive" }}>
            {" "}
            to all of you at Home page of the Site
          </span>
        </BallMove>
      </SiteHome>
      </>
    );
}

export default Sitehome
